import { render, staticRenderFns } from "./Backup.vue?vue&type=template&id=188d7cd6&scoped=true"
import script from "./Backup.vue?vue&type=script&lang=js"
export * from "./Backup.vue?vue&type=script&lang=js"
import style0 from "./Backup.vue?vue&type=style&index=0&id=188d7cd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188d7cd6",
  null
  
)

export default component.exports